<template>
  <ValidationProvider
    :rules="field.validation"
    v-slot="{ errors }"
    :name="field.label"
  >
    <div :class="fieldClass">
      <input
        :type="field.type"
        :class="{
          'textarea': true,
          'is-danger': errors.length > 0,
          'is-success': !errors.length > 0 && value,
        }"
        :placeholder="field.placeholder"
        :name="field.name"
        :id="`${field.name}-field`"
        @blur="updateFormData"
        v-model="value"
        autocomplete="nope"
      >
      <span class="icon is-small is-left has-text-grey" v-if="field.icon">
        <fa :icon="field.icon"></fa>
      </span>
      <span
        class="icon is-small is-right has-text-danger"
        v-if="field.validation.required && errors.length === 0 && !value"
      >
        <fa icon="asterisk" class="fa-xs"></fa>
      </span>
      <span
        class="icon is-small is-right has-text-danger"
        v-if="errors.length > 0"
      >
        <fa icon="exclamation-triangle"></fa>
      </span>
      <span
        class="icon is-small is-right has-text-success"
        v-if="!errors.length > 0 && value"
      >
        <fa icon="check"></fa>
      </span>
    </div>
    <p class="help is-danger" v-if="errors" v-html="errors[0]"></p>
  </ValidationProvider>
</template>

<script>
export default {
  props: {
    field: {
      type: Object,
      required: true,
    },
  },
  computed: {
    fieldClass() {
      return {
        control: true,
        'has-icons-right': true,
        'has-icons-left': this.field.icon,
      };
    },
  },
  methods: {
    updateFormData(e) {
      const field = {
        name: e.target.name,
        value: this.value,
      };
      this.$store.dispatch('addToSubmission', field);
    },
  },
  mounted() {
    const field = {
      name: this.field.name,
      value: null,
    };
    this.$store.dispatch('addToSubmission', field);
  },
};
</script>
